(function () {
  function closeBoostSearchPopup() {
    const activeElement = document.activeElement;
    if (activeElement && activeElement.matches('[data-in-collection-search-empty-input]')) {
      activeElement.blur();
    }

    document
      .querySelectorAll('#boost-sd__search-widget-init-wrapper, .boost-sd__search-widget-init-wrapper')
      .forEach(function (popup) {
        popup.remove();
      });

    document
      .querySelectorAll('[aria-controls="boost-sd__search-widget-init-wrapper"], [aria-owns="boost-sd__search-widget-init-wrapper"]')
      .forEach(function (input) {
        input.setAttribute('aria-expanded', 'false');
      });

    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
  }

  function initializeBoostCollection(section) {
    const productFilterBlock = section.querySelector(
      '.boost-sd__filter-product-list.boost-sd__fpl-app-block'
    );

    if (window.boostWidgetIntegration?.simplifiedIntegration?.enabled) {
      productFilterBlock?.remove();
      return;
    }

    if (window.boostSDTaeUtils && window.boostSDTaeUtils.initCollectionFilter) {
      window.boostSDTaeUtils.initCollectionFilter();
    }
  }

  function scrollCollectionToTop(section) {
    window.requestAnimationFrame(function () {
      const rootStyles = window.getComputedStyle(document.documentElement);
      const headerHeight = parseFloat(rootStyles.getPropertyValue('--header-sticky-height')) || 0;
      const announcementHeight = parseFloat(rootStyles.getPropertyValue('--announcement-height')) || 0;
      const sectionTop = window.scrollY + section.getBoundingClientRect().top;

      window.scrollTo({
        top: Math.max(0, sectionTop - headerHeight - announcementHeight - 16),
        behavior: 'smooth'
      });
    });
  }

  function initializeCollectionApps(section, queryOverride) {
    if (section.dataset.collectionAppsInitialized === 'true') return;
    section.dataset.collectionAppsInitialized = 'true';

    const emptyState = section.querySelector('[data-in-collection-search-empty]');
    const emptyForm = section.querySelector('[data-in-collection-search-empty-form]');
    const emptyInput = section.querySelector('[data-in-collection-search-empty-input]');
    if (!emptyState || !emptyForm || !emptyInput) return;

    let currentQuery = typeof queryOverride === 'string'
      ? queryOverride
      : new URLSearchParams(window.location.search).get('q') || '';
    let evaluationTimer;

    emptyInput.value = currentQuery;

    function evaluateSearchResults() {
      const productList = section.querySelector('.boost-sd__filter-product-list');
      const hasProducts = Boolean(section.querySelector('.boost-sd__product-item'));
      const isLoading = Boolean(
        section.querySelector('.boost-sd__product-list-placeholder, .boost-sd__placeholder-item')
      );
      const hasBoostEmptyState = Boolean(
        section.querySelector('.boost-sd__no-search-result, .boost-sd__no-result, [data-group="empty"]')
      );
      const hasSettledProductList = Boolean(
        productList && productList.classList.contains('boost-sd__filter-product-list--ready')
      );
      const showEmptyState = Boolean(
        currentQuery && !hasProducts && !isLoading && (hasBoostEmptyState || hasSettledProductList)
      );

      if (showEmptyState && document.activeElement !== emptyInput) {
        emptyInput.value = currentQuery;
      }

      emptyState.hidden = !showEmptyState;
      section.classList.toggle('has-in-collection-search-empty', showEmptyState);
    }

    function scheduleEvaluation() {
      window.clearTimeout(evaluationTimer);
      evaluationTimer = window.setTimeout(evaluateSearchResults, 350);
    }

    async function renderCollectionSection(destination, updateHistory) {
      const sectionId = section.dataset.sectionType;
      const requestUrl = new URL(destination);
      requestUrl.searchParams.set('section_id', sectionId);
      emptyForm.setAttribute('aria-busy', 'true');
      emptyInput.disabled = true;

      try {
        const response = await fetch(requestUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('Unable to render collection section');

        const html = await response.text();
        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        const parsedSection = parsedDocument.querySelector('[data-collection-apps]');
        if (!parsedSection) throw new Error('Collection section missing from response');

        parsedSection.querySelectorAll('script').forEach(function (script) {
          script.remove();
        });

        const nextSection = document.importNode(parsedSection, true);
        section.replaceWith(nextSection);

        if (updateHistory) {
          window.history.pushState({ collectionSearch: true }, '', destination.toString());
        }

        initializeBoostCollection(nextSection);
        initializeCollectionApps(nextSection, destination.searchParams.get('q') || '');
        closeBoostSearchPopup();
        scrollCollectionToTop(nextSection);
      } catch (error) {
        window.location.assign(destination.toString());
      }
    }

    function submitFallbackSearch(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeBoostSearchPopup();

      const url = new URL(emptyForm.action, window.location.origin);
      const query = emptyInput.value.trim();
      url.searchParams.delete('page');

      if (query) {
        url.searchParams.set('q', query);
      } else {
        url.searchParams.delete('q');
      }

      renderCollectionSection(url, true);
    }

    emptyForm.addEventListener('submit', submitFallbackSearch, true);

    emptyInput.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      submitFallbackSearch(event);
    }, true);

    section.addEventListener('input', function (event) {
      if (!event.target.matches('.boost-sd__in-collection-search-input')) return;
      currentQuery = event.target.value.trim();
      scheduleEvaluation();
    });

    if (window.collectionAppsPopstateHandler) {
      window.removeEventListener('popstate', window.collectionAppsPopstateHandler);
    }

    window.collectionAppsPopstateHandler = function () {
      renderCollectionSection(new URL(window.location.href), false);
    };
    window.addEventListener('popstate', window.collectionAppsPopstateHandler);

    new MutationObserver(scheduleEvaluation).observe(section, { childList: true, subtree: true });
    window.setTimeout(evaluateSearchResults, 800);
  }

  window.initializeCollectionApps = initializeCollectionApps;
  document.querySelectorAll('[data-collection-apps]').forEach(initializeCollectionApps);
})();
